import { ASSETS } from '../../assets';

export const CITIES = [{ key: 'tel_aviv' }, { key: 'new_york' }, { key: 'kyiv' }] as const;

export const PHOTOS = [
    ASSETS.siteImg1,
    ASSETS.siteImg2,
    ASSETS.siteImg3,
    ASSETS.siteImg4,
    ASSETS.siteImg5,
    ASSETS.siteImg6,
    ASSETS.siteImg7,
    ASSETS.siteImg8,
];
